import React from 'react';
import {
  Target,
  Plus,
  Archive,
} from 'lucide-react';

import { Button } from "../../../components/ui/button";

export default function ProspectHeader({
  onAdd,
  onArchiveView,
}) {
  return (
    <div
      className="
        relative z-20
        flex shrink-0 flex-col
        gap-6
        overflow-visible
        workspace-card
        bg-cover bg-center bg-no-repeat
        p-4 sm:p-6
        mb-6
        xl:flex-row xl:items-center xl:justify-between
      "
      style={{
        backgroundImage:
          "url('/assets/backgrounds/river_bg.png')",
      }}
    >
      {/* Voile sombre utilisant les tokens Hipparchus */}
      <div
        aria-hidden="true"
        className="
          pointer-events-none
          absolute inset-0 z-0
          rounded-[var(--hp-radius-lg)]
          bg-overlay
        "
      />

      {/* Partie gauche : titre et icône */}
      <div
        className="
          relative z-10
          flex min-w-0 shrink-0
          flex-col items-start
          gap-3
          sm:flex-row sm:items-center sm:gap-4
        "
      >
        <div
          className="
            flex h-12 w-12 shrink-0
            items-center justify-center
            rounded-full
            bg-secondary
            text-inverse
            shadow-hp-sm
          "
        >
          <Target className="h-6 w-6" />
        </div>

        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-inverse">
            Gestion des prospects
          </h1>

          <p className="mt-1 text-sm text-inverse opacity-80">
            Suivez et convertissez vos prospects en clients.
          </p>
        </div>
      </div>

      {/* Partie droite : actions */}
      <div
        className="
          relative z-50
          flex w-full min-w-0
          flex-col gap-3
          xl:w-auto xl:flex-row xl:items-center
        "
      >
        {/* Boutons */}
        <div
          className="
            relative z-[60]
            flex flex-wrap items-center
            gap-3
          "
        >
          <Button
            variant="accent"
            onClick={onAdd}
          >
            <Plus className="h-4 w-4 mr-2" />
            Nouveau
          </Button>

          <div
            aria-hidden="true"
            className="
              mx-1 hidden h-8
              border-l border-workspace
              sm:block
            "
          />

          <Button
            variant="secondary"
            onClick={onArchiveView}
          >
            <Archive className="h-4 w-4 mr-2" />
            Archives
          </Button>
        </div>
      </div>
    </div>
  );
}
